export default {
    init: el => {
        const body = document.body;
        const menuBtn = el.querySelector('.js-hamburger');
        const searchBtn = el.querySelector('.js-search-btn');
        const searchOverlay = el.querySelector('.js-search-overlay');
        const desktopSearchForm = el.querySelector('.js-desktop-search-form');
        const desktopSearchInput = el.querySelector('.js-search-input');
        const formError = el.querySelector('.js-error');
        const desktopSearchContainer = el.querySelector('.js-desktop-search-container');
        const desktopSearchCloseBtn = el.querySelector('.js-desktop-search-close');
        let lastScroll
        const activeClass = "visible";

        window.addEventListener("scroll", () => {
            const currentScroll = window.scrollY;

            if (currentScroll <= 0 & !el.classList.contains(activeClass)) {
                el.classList.add(activeClass);
                return;
            }

            if (currentScroll > lastScroll && el.classList.contains(activeClass)) {
                el.classList.remove(activeClass);
            } else if (
                currentScroll < lastScroll &&
                !el.classList.contains(activeClass)
            ) {
                el.classList.add(activeClass);
            }

            lastScroll = currentScroll
        })

        menuBtn.addEventListener('click', event => {
            if (menuBtn.classList.contains('is-active')) {
                body.classList.remove('modal-open');
            } else {
                body.classList.add('modal-open');
            }

            menuBtn.classList.toggle('is-active');
            el.classList.toggle('menu-open');
        });

        searchBtn && searchBtn.addEventListener('click', event => {
            el.classList.add('search-open');

            // wait for next frame
            setTimeout(() => {
                body.classList.add('modal-open');
                desktopSearchContainer.classList.add('active');
                desktopSearchInput.focus();
            });
        });

        searchOverlay && searchOverlay.addEventListener('click', event => {
            closeSearch();
        });

        desktopSearchCloseBtn && desktopSearchCloseBtn.addEventListener('click', event => {
            closeSearch();
        });

        searchBtn && document.addEventListener('keyup', event => {
            if (event.key === 'Escape') {
                closeSearch();
            }
        });

        desktopSearchForm && desktopSearchForm.addEventListener('submit', event => {
            if (!desktopSearchInput.value) {
                formError.classList.remove('hidden');
                event.preventDefault();
            } else {
                formError.classList.add('hidden');
            }
        });

        function closeSearch() {
            desktopSearchContainer.classList.remove('active');
            body.classList.remove('modal-open');

            // wait for exit transition 
            setTimeout(() => {
                el.classList.remove('search-open');
            }, 200);
        }
    }
}